export default __webpack_public_path__ + "static/media/columns.ef0a5eb5.svg";